import React from 'react';

import '../assets/css/eventDescription.css';

function EventDescription(props) {
  return ( 
    
        <div class="card">
            <div class="img">
              {/* <img src={props.poster} alt='img'/> */}
              <h4>{props.name}</h4>
            </div>
            <div class="content">
              <p>
               {props.description}   
              </p>
            </div>
        </div>
    
  )
}

export default EventDescription